var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cp-confirm-modal',{ref:"cpConfirmModal",attrs:{"title":_vm.$t('investorsCommon.button.investor.delete'),"item":_vm.item},on:{"onOk":_vm.removeInvestor}},[_vm._v(" "+_vm._s(_vm.confirmModalText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }